<div class="terms-of-service" [formGroup]="parentForm">
  <ng-container formArrayName="formArray">
    <div
      class="checkbox-container"
      *ngFor="let tos of formArray.controls; let i = index"
    >
      <mat-checkbox
        [formControl]="tos"
        [required]="terms[i].required"
        id="terms-checkbox-{{ i }}"
      >
        <span
          #term
          *ngIf="terms[i].innerHtml"
          [innerHtml]="terms[i].text"
        ></span>
        <span #term *ngIf="!terms[i].innerHtml && terms[i].linkTitle">
          {{ terms[i].text }}
          <a target="_blank" href="{{ terms[i].termsOfServiceUrl }}">
            {{ terms[i].linkTitle }}
          </a>
        </span>
        <span #term *ngIf="!terms[i].innerHtml && !terms[i].linkTitle">
          {{ terms[i].text }}
          <a target="_blank" href="{{ terms[i].termsOfServiceUrl }}">
            {{ terms[i].termsOfServiceUrl }}
          </a>
        </span>
      </mat-checkbox>
    </div>
  </ng-container>
</div>
